var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 2.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2941176,7.76470588 L8.47058824,7.76470588 C8.08023529,7.76470588 7.76470588,8.08023529 7.76470588,8.47058824 L7.76470588,9.17647059 C4.94117647,9.17647059 2.868,7.01505882 2.82352941,4.23529412 L3.52941176,4.23529412 C3.91976471,4.23529412 4.23529412,3.91976471 4.23529412,3.52941176 L4.23529412,0.705882353 C4.23529412,0.315529412 3.91976471,0 3.52941176,0 L0.705882353,0 C0.316235294,0 0,0.315529412 0,0.705882353 L0,4.23529412 C0,8.52352941 3.47647059,12 7.76470588,12 L11.2941176,12 C11.6844706,12 12,11.6844706 12,11.2941176 L12,8.47058824 C12,8.08023529 11.6844706,7.76470588 11.2941176,7.76470588 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a45f8cb7375263030341f09bfe60bc59.svg";
export { ForwardRef as ReactComponent };